import './about.scss';

export default function About(){
    return (
        <div className="about" id="about">
           <div className="abthead"><h1>About Us</h1></div> 
           <div className="abtContent">Ciphers is an initiative started by a group of enthusiastic coders of SRGI Lucknow . Here, we not only introduce coding to students who have never given it a thought , but also provide mentorship and assistance to all the students throughout their journey .Various coding contests are also organized to inculcate sense of competition, as well as instill confidence in the students. All of us here at Ciphers mainly aim at providing a 
           healthy and supportive environment for the students so that they can master their problem solving skills, 
           replace their fears with motivation and inspiration, and have the confidence to overcome the challenges of 
           tomorrow and reach greater heights.</div>
        </div>
    );
}


